<template>
    <header class="pane-header">

    <slot>
        <section class="pane-header__section--left">
            <button v-if="showBackButton" @click="tools.navigate.goBack" class="pane-header-button left">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
<g>
	<path d="M15.5,19.75c-0.192,0-0.384-0.073-0.53-0.22l-7-7c-0.293-0.293-0.293-0.768,0-1.061l7-7c0.293-0.293,0.768-0.293,1.061,0
		c0.293,0.293,0.293,0.768,0,1.061L9.56,12l6.47,6.47c0.293,0.293,0.293,0.768,0,1.061C15.884,19.676,15.692,19.75,15.5,19.75z"/>
</g>
</svg>
                <span>Back</span>
            </button>

            <button v-if="showCloseButton" @click="tools.navigate.goBack" class="pane-header-button left">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284
                                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414
                                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293
                                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"></path></svg>
                <span>Close</span>
            </button>


            <button v-if="hasCloseSearchIcon" @click="() => tools.actions.togglePane('search')" class="pane-header-button left">
                <!-- <ui-icon name="times" /> -->
                <svg v-once version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
                <path d="M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284
                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414
                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293
                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"/>
                </svg>
 </button>

            <button v-if="hasCloseIcon" @click="() => tools.actions.closePreviewPane()" class="pane-header-button left">
                <svg v-once version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
                <path d="M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284
                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414
                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293
                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"/>
                </svg>
            </button>
            <button v-if="hasSearchIcon" @click="() => tools.actions.togglePane('search')" class="pane-header-button left">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
<path d="M19.707,18.293l-4.049-4.048c1.838-2.521,1.628-6.081-0.647-8.355c-2.515-2.515-6.607-2.515-9.123,0
	c-2.515,2.515-2.515,6.608,0,9.123c1.258,1.258,2.91,1.886,4.562,1.886c1.335,0,2.667-0.418,3.793-1.239l4.049,4.048
	C18.488,19.902,18.744,20,19,20s0.512-0.098,0.707-0.293C20.098,19.316,20.098,18.683,19.707,18.293z M7.303,13.598
	c-1.735-1.735-1.735-4.56,0-6.295c0.868-0.868,2.007-1.301,3.147-1.301c1.14,0,2.279,0.434,3.147,1.301
	c1.735,1.735,1.735,4.56,0,6.295C11.862,15.333,9.039,15.333,7.303,13.598z"/>
</svg>
            </button>
            <slot name="left" />
        </section>

        <section class="pane-header__section--center">
            <section class="pane-header__title">
                <app-icon v-if="appIconKey" :tools="tools" :name="appIconKey" />
                <slot name="title" class="pane-header__title-label" tag="span">{{ title }}</slot>
            </section>
            <section class="pane-header__subtitle">
                <slot name="subtitle" class="pane-header__title-label" tag="span">{{ subtitle }}</slot>
            </section>
        </section>

       <section class="pane-header__section--right">

           <slot name="right"></slot>
       </section>
   </slot>
    </header>
</template>

<script>
    export default {
        name: 'pane-header',
        props: ['title', 'subtitle', 'hasSearchIcon', 'tools', 'hasBackButton', 'appIconKey', 'hasCloseIcon', 'hasCloseSearchIcon'],
        data() {
            return {
                showSearchPane: true,
            };
        },
        computed: {
            showCloseButton() {
                return this.hasBackButton === true && this.tools.modifiers.hideBackButton !== false && this.tools.modifiers.currentBackButtonBehavior === 'show_close';
            },
            showBackButton() {
                return this.hasBackButton === true && this.tools.modifiers.hideBackButton !== false && this.tools.modifiers.currentBackButtonBehavior === 'show_back';
            },
        },
    };
</script>

<style>
.pane-header {
    line-height: 100%;
    width: 100%;
    padding: 0 10px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    height: 44px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    /*flex: 0 0 44px;*/
    flex: 1 0 44px;
}

.pane-header__section--left{
    flex: 0 0 44px;
 }

 .pane-header__section--center {
     display: flex;
     flex-flow: column;
     align-items: center;
    width:100%;
    white-space: nowrap;
 }

 .pane-header__section--right{
    flex: 0 0 auto;
 }

 .pane-header-button{
     height:44px;
     min-width:44px;
     display:flex;
     flex-flow:row nowrap;
     justify-content: center;
     align-items: center;
     font-size: 13px;
     opacity: 0.8;
     padding:0;
 }

  .pane-header-button:hover {
      opacity: 1;
  }

 .pane-header-button svg{
     height:24px;
     width:24px;
     fill:rgba(0,0,0,0.5);
 }


 .pane-header-button span {
     margin-left: 0px;
 }

  .pane-header-button .ui-icon {
      margin-top: 2px;
  }

 .pane-header-button.left {
     margin-left: -10px;
 }

.pane-header__section--right .ui-button{
    margin-right:5px;
}


.pane-header__title-label{
justify-content: center;
}
 .pane-header__title{
   justify-content: flex-start;
   font-size: 1em;
   line-height:1.2em;
   font-weight: 600;
   display: flex;
   align-items: center;
   white-space: nowrap;
}

.pane--preview .pane-header__title{
    max-width:500px;
   overflow: hidden;
   text-overflow: ellipsis;

}
/*@media (min-width: 1201px) {
     .pane-header__title{
         width:600px;
     }
}*/

.pane-header__title img {
    margin-right: 5px;
}

.pane-header__subtitle{
   font-size: 0.75em;
   line-height: 100%;
   margin-top: 3px;
justify-content: center;
    color:#B3B4B5;
}

</style>



// WEBPACK FOOTER //
// PaneHeader.vue?a04e8a1a